const treedata = [
//   {
//     id: 1,
//     label: "系统管理",
//     children: [
//       {
//         id: 4,
//         label: "用户管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "新增",
//           },
//           {
//             id: 11,
//             label: "修改",
//           },
//           {
//             id: 12,
//             label: "删除",
//           },
//           {
//             id: 13,
//             label: "启停用",
//           },
//           {
//             id: 14,
//             label: "提交",
//           },
//           {
//             id: 15,
//             label: "分配角色",
//           },
//         ],
//       },
//       {
//         id: 5,
//         label: "角色管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "新增",
//           },
//           {
//             id: 11,
//             label: "修改",
//           },
//           {
//             id: 12,
//             label: "删除",
//           },
//           {
//             id: 13,
//             label: "启停用",
//           },
//           {
//             id: 14,
//             label: "提交",
//           },
//         ],
//       },
//       {
//         id: 6,
//         label: "权限列表",
//       },
//       {
//         id: 7,
//         label: "菜单管理",
//       },
//       {
//         id: 8,
//         label: "菜单权限",
//       },
//       {
//         id: 9,
//         label: "用户角色权限列表",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "新增",
//           },
//           {
//             id: 11,
//             label: "修改",
//           },
//           {
//             id: 12,
//             label: "删除",
//           },
//           {
//             id: 13,
//             label: "启停用",
//           },
//           {
//             id: 14,
//             label: "提交",
//           },
//           {
//             id: 15,
//             label: "分配角色",
//           },
//         ],
//       },
//       {
//         id: 5,
//         label: "部门管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "新增",
//           },
//           {
//             id: 11,
//             label: "修改",
//           },
//           {
//             id: 12,
//             label: "删除",
//           },
//           {
//             id: 13,
//             label: "启停用",
//           },
//           {
//             id: 14,
//             label: "提交",
//           },
//           {
//             id: 15,
//             label: "分配角色",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     id: 2,
//     label: "基础档案管理",
//     children: [
//       {
//         id: 5,
//         label: "经销商",
//         children: [
//           {
//             id: 1,
//             label: "一级经销商档案",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//               {
//                 id: 13,
//                 label: "启停用",
//               },
//               {
//                 id: 14,
//                 label: "配置",
//               },
//             ],
//           },
//           {
//             id: 2,
//             label: "二级经销商档案",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//               {
//                 id: 13,
//                 label: "启停用",
//               },
//               {
//                 id: 14,
//                 label: "配置",
//               },
//             ],
//           },
//         ],
//       },
//       {
//         id: 6,
//         label: "产品",
//         children: [
//           {
//             id: 1,
//             label: "产品线档案",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//               {
//                 id: 13,
//                 label: "启停用",
//               },
//             ],
//           },
//           {
//             id: 2,
//             label: "产品档案",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//               {
//                 id: 13,
//                 label: "启停用",
//               },
//             ],
//           },
//         ],
//       },
//       {
//         id: 7,
//         label: "业务",
//         children: [
//           {
//             id: 1,
//             label: "仓库档案",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//               {
//                 id: 13,
//                 label: "启停用",
//               },
//             ],
//           },
//           {
//             id: 2,
//             label: "医院档案",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//               {
//                 id: 13,
//                 label: "启停用",
//               },
//             ],
//           },
//           {
//             id: 3,
//             label: "经销商医院指标维护",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//             ],
//           },
//           {
//             id: 4,
//             label: "销售区域",
//             children: [
//               {
//                 id: 9,
//                 label: "浏览",
//               },
//               {
//                 id: 10,
//                 label: "新增",
//               },
//               {
//                 id: 11,
//                 label: "修改",
//               },
//               {
//                 id: 12,
//                 label: "删除",
//               },
//             ],
//           },
//         ],
//       },
//       {
//         id: 8,
//         label: "报表",
//       },
//     ],
//   },
//   {
//     id: 3,
//     label: "发票管理",
//     children: [
//       {
//         id: 7,
//         label: "发票上报管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "删除",
//           },
//           {
//             id: 11,
//             label: "启停用",
//           },
//           {
//             id: 12,
//             label: "弃审",
//           },
//           {
//             id: 13,
//             label: "新增",
//           },
//           {
//             id: 14,
//             label: "修改",
//           },
//           {
//             id: 15,
//             label: "配置",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     id: 4,
//     label: "出入库管理",
//     children: [
//       {
//         id: 4,
//         label: "入库上报管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "删除",
//           },
//           {
//             id: 11,
//             label: "启停用",
//           },
//           {
//             id: 12,
//             label: "弃审",
//           },
//           {
//             id: 13,
//             label: "修改",
//           },
//         ],
//       },
//       {
//         id: 5,
//         label: "出库上报管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "删除",
//           },
//           {
//             id: 11,
//             label: "启停用",
//           },
//           {
//             id: 12,
//             label: "弃审",
//           },
//           {
//             id: 13,
//             label: "修改",
//           },
//         ],
//       },
//       {
//         id: 6,
//         label: "调拨单管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "删除",
//           },
//           {
//             id: 11,
//             label: "启停用",
//           },
//           {
//             id: 12,
//             label: "弃审",
//           },
//         ],
//       },
//       {
//         id: 7,
//         label: "医院销售出库上报",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "删除",
//           },
//           {
//             id: 11,
//             label: "启停用",
//           },
//           {
//             id: 12,
//             label: "弃审",
//           },
//         ],
//       },
//       {
//         id: 8,
//         label: "经销商库存上报对账",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "删除",
//           },
//           {
//             id: 11,
//             label: "启停用",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     id: 5,
//     label: "报表",
//     children: [
//       {
//         id: 7,
//         label: "入库单列表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 8,
//         label: "出库单列表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 9,
//         label: "发票列表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 10,
//         label: "库存列表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 11,
//         label: "唯一码库存列表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 12,
//         label: "经销商销售出库报表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 13,
//         label: "经销商达成率",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 14,
//         label: "经销商采购入库报表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 15,
//         label: "U8销售订单报表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 16,
//         label: "U8发货单报表",
//         children: [
//           {
//             id: 11,
//             label: "浏览",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     id: 6,
//     label: "接口管理",
//     children: [
//       {
//         id: 7,
//         label: "U8接口管理",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//           {
//             id: 10,
//             label: "修改",
//           },
//           {
//             id: 11,
//             label: "跳过",
//           },
//           {
//             id: 12,
//             label: "重置",
//           },
//         ],
//       },
//       {
//         id: 8,
//         label: "发票二次校验",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//         ],
//       },
//       {
//         id: 9,
//         label: "票查查校验",
//         children: [
//           {
//             id: 9,
//             label: "浏览",
//           },
//         ],
//       },
//     ],
//   },
];

export default treedata;
